<div>
  <button class="ficon-arrow-left back-btn" role="button" aria-label="back" (click)="onBack.emit()"></button>
</div>

<div class="content" #content>
  <h2 class="title" translate="create-org_note"></h2>

  <!-- Form -->
  <ng-container [formGroup]="form">
    <div goRequiredFieldsNote></div>

    <mat-form-field appearance="outline">
      <mat-label>{{'common_type' | translate}}</mat-label>
      <mat-select
        formControlName="type"
        data-cy="org-create-form-type-dropdown"
        disableOptionCentering
        panelClass="offsetPanel">
        <mat-select-trigger class="type-label">{{form.controls.type.value?.display_name}}</mat-select-trigger>
        @for (orgType of (orgTypes$ | async); track orgType) {
          <mat-option [value]="orgType">
            <strong translate>{{orgType.display_name}}</strong>
            <span class="description" translate>{{orgType.description}}</span>
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.type.hasError('required')) {
        <mat-error>{{'account-setup-error-required-org_type' | translate}}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{'common_organization-name' | translate}}</mat-label>
      <input type="text" matInput formControlName="name" data-cy="org-create-form-org-name" maxlength="60">
      @if (form.controls.name.hasError('required') || form.controls.name.hasError('whitespace')) {
        <mat-error>
          {{'account-setup-error-required-org_name' | translate}}
        </mat-error>
      }
      @if (form.controls.name.hasError('orgNameUniqueValidator')) {
        <mat-error>
          {{'account-setup-error-org-name-exists' | translate}}
        </mat-error>
      }
      @if (form.controls.name.hasError('maxlength')) {
        <mat-error>
          {{'account-setup-error-org-name-too-long' | translate}}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" id="country-selector-wrapper">
      <mat-label>{{'common_country' | translate}}</mat-label>
      <mat-select
        formControlName="country"
        data-cy="org-create-form-country"
        id="country-selector"
        disableOptionCentering
        panelClass="offsetPanel">
        @for (country of countries; track country) {
          <mat-option [value]="country.code">
            {{ country.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.country.hasError('required')) {
        <mat-error>{{'account-setup-error-required-org_country' | translate}}</mat-error>
      }
    </mat-form-field>

    @if (shouldShowOrgJoinViaEmailDomainCheckbox) {
      <mat-checkbox
        (click)="toggleOrgJoinViaEmailDomain()"
        formControlName="orgJoinViaEmailDomain"
        color="primary"
        class="org-join-via-email-domain-checkbox new-checkbox">
        <span [innerHTML]="'account-setup-org-join-via-email-domain-checkbox-label' | translate: {domain: domain}"></span>
      </mat-checkbox>
    }
  </ng-container>

  <button
    class="continue-btn primary-btn"
    (click)="submit()"
    data-cy="org-create-form-create-btn"
  [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">{{'common_continue' | translate}}</button>
</div>
